// @flow
import PassengersCount from "common/records/PassengersCount"
import type Journey from "common/records/Journey"

export default (journey: Journey, passengers: PassengersCount) => ({
  origin: journey.getDeparture().getIn(["where", "code"]),
  originCity: journey.getDeparture().getIn(["where", "name"]),
  destination: journey.getArrival().getIn(["where", "code"]),
  destinationCity: journey.getArrival().getIn(["where", "name"]),
  dateOfDeparture: journey
    .getDeparture()
    .getIn(["when", "local"])
    .unix(),
  dateOfDepartureUtc: journey
    .getDeparture()
    .getIn(["when", "utc"])
    .unix(),
  dateOfReturn: !journey.isOneWay()
    ? journey
        .getArrival()
        .getIn(["when", "local"])
        .unix()
    : null,
  dateOfReturnUtc: !journey.isOneWay()
    ? journey
        .getArrival()
        .getIn(["when", "utc"])
        .unix()
    : null,

  price: journey.getBestPrice(),
  currency: "EUR",
  num_adults: passengers.get("adults"),
  num_children: passengers.get("children"),
  num_infants: passengers.get("infants"),
  is_metasearch: journey.getIn(["sources"]).toArray()[0] !== "kiwi",
  flight_type: journey.getType(),
})
